import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import theme from './loadingTheme.css';

const Overlay = glamorous.div({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: '#000000',
  opacity: 0.4,
  zIndex: 500,
});

const ProgressBarContainer = glamorous.div({
  position: 'fixed',
  top: 'calc(50% - 30px)',
  left: 'calc(50% - 30px)',
  zIndex: 550,
});

const LoadingOverlay = ({ children, isLoading }) => {
  if (isLoading) {
    return (
      <div>
        <Overlay />
        <ProgressBarContainer>
          {children ||
            <ProgressBar
              type="circular"
              mode="indeterminate"
              multicolor
              className={theme.progressBar}
              theme={theme}
            />}
        </ProgressBarContainer>
      </div>
    );
  }
  return null;
};

LoadingOverlay.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node,
};

export default LoadingOverlay;



// WEBPACK FOOTER //
// ./src/common/components/LoadingOverlay/index.js